module.exports = __webpack_public_path__ + "static/media/logo_white_1024.57b01e14.png";